export default __webpack_public_path__ + "static/media/JTs-Mobile-Banner.1986c6de.webp";